import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { PayableReviewComponent } from '../../payable-review/payable-review.component';
import { GrowlerService } from '../../../../shared/growler/growler.service';
import { finalize, take } from 'rxjs/operators';
import { Payable } from '../../../../../models/entities/payable';
import { PayablesService } from '../../../../../services/payables/payables.service';
import { CsvExportService } from '../../../../../services/csv-export/csv-export.service';

export interface DownloadCheckDialogInput {
    payable: Payable;
}

export interface DownloadCheckDialogResult {
    success: boolean;
}

@Component({
    selector: 'app-download-check-dialog',
    templateUrl: './download-check-dialog.component.html',
    standalone: true,
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        PayableReviewComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DownloadCheckDialogComponent {
    @Input() open = false;
    @Input() payable: Payable | null = null;
    @Output() closed = new EventEmitter<DownloadCheckDialogResult | null>();

    isDownloading: boolean = false;
    constructor(
        private _growler: GrowlerService,
        private _payablesService: PayablesService,
        private _csvExportService: CsvExportService,
    ) {}

    get headerText(): string {
        return this.payable?.invoiceNumber ? ' - ' + this.payable.invoiceNumber : '';
    }

    closeDialog(success: boolean = false) {
        this.closed.emit(success ? { success: true } : null);
    }

    downloadCheck() {
        this.isDownloading = true;
        this._payablesService.downloadPrintableCheckFile(this.payable)
            .pipe(
                finalize(() => this.isDownloading = false),
                take(1),
            )
            .subscribe({
                next: (response) => {
                    this._growler.success('Success', 'Check download started');
                    this._csvExportService.downloadFile(
                            response,
                            'printable_check.pdf',
                            'application/pdf'
                    );
                    this.closeDialog(true);
                },
                error: () => {
                    this._growler.oops('There was a problem downloading the check');
                }
            });
    }
}
